<template>
  <div class="container-fluid p-3">
    <div class="card">
      <div class="card-header">
        <h5 class="text-center">ASIGNACIÓN DE EQUIPOS</h5>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-12 col-md-5">
            <h6 class="title-panel pb-3">ASIGNAR EQUIPO A VUELO <i class="fa fa-plane" style="color:#7366ff"></i></h6>
            <div class="pb-4">
              <button type="button" class="btn btn-danger btn-sm btn-block" @click="setConfiguracionFlujo">
                <i class="fa fa-recycle"></i> REINICIAR CONFIGURACIÓN DE VUELOS
              </button>
            </div>
            
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col-12 col-md-12">
                    <div class="alert alert-light" role="alert">
                      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> <small>Seleccione <b>Empresa</b> y <b>Vuelo</b>, luego haga click en boton <b>AÑADIR</b> para adicionar el equipo al vuelo.</small>
                    </div>
                  </div>
                </div>

                <div class="form-group mt-3">
                  <label class="font-weight-bold mr-1">Empresa:</label>
                  <span
                    class="text-danger text-help"
                    v-if="!$v.nombre_empresas.id_empresa.required"
                    ><small>Campo requerido</small>
                  </span>
                  <select
                    class="custom-select"
                    :class="{ 'is-invalid': $v.nombre_empresas.id_empresa.$error }"
                    v-model="nombre_empresas.id_empresa"
                    @change="getConfigEmpresa(nombre_empresas.id_empresa)"
                  >
                    <option value="">SELECCIONAR</option>
                    <option
                      v-for="(t, i) in vempresas"
                      :value="t.id_empresa"
                      :key="t.nombre_empresa + i"
                      >{{ t.nombre_empresa}}</option
                    >
                  </select>
                </div>

                <div class="form-group">
                  <label class="font-weight-bold mr-1">Vuelo:</label>
                  <span
                    class="text-danger text-help"
                    v-if="!$v.vuelo.id_config_empresa.required"
                    ><small>Campo requerido</small>
                  </span>
                  <select
                    class="custom-select"
                    :class="{ 'is-invalid': $v.vuelo.id_config_empresa.$error }"
                    v-model="vuelo.id_config_empresa"
                    @change="buscarAsignados(vuelo.id_config_empresa)"
                  >
                    <option value="">SELECCIONAR</option>
                    <option
                      v-for="(t, i) in confempresa"
                      :value="t.id_config_empresa"
                      :key="t.nro_vuelo + i"
                      >{{ t.nro_vuelo}}</option
                    >
                  </select>
                </div>
              </div>
            </div>
            
          </div>
          <div class="col-12 col-md-7">
            <h6 class="title-panel pb-3">VUELOS ACTIVOS</h6>
            <div class="row">
              <div class="col-12 col-md-6" v-for="(item, index) in vuelosActivos" :key="index">
                
                <div class="chart_data_right card-flujo">
                  <px-card>
                    <div slot="with-padding">
                      <div class="media align-items-center">
                        <div class="media-body right-chart-content">
                          <h4>
                            {{item.empresa}}
                            <span class="new-box">{{item.vuelo}}</span>
                          </h4>
                          <span>{{item.ruta}}</span>
                        </div>
                        <!-- <Knob v-bind:valor="item.cantidad_equipos" v-bind:id="index+1" /> -->
                        <div class="knob">{{item.cantidad_equipos}}</div>
                      </div>
                      <div class="mt-3 text-center"><button class="btn btn-dark btn-sm" @click="Revisar(item.id)">REVISAR</button></div>
                    </div>
                    
                  </px-card>
                </div>
                
              </div>
              
            </div>
            
          </div>
        </div>
        
        <div class="row mt-4 pb-5">
          <!--Izquierda-->
          <div class="col-12 col-md-5">
            <h6 class="title-panel">EQUIPOS LIBRES</h6>
            <table class="table table-striped table-bordered">
              <thead>
                <tr class="text-center">
                  <!-- <th><small class="font-weight-bold">#</small></th> -->
                  <th>
                    <small class="font-weight-bold">NOMBRE EQUIPO</small>
                  </th>
                  <!-- <th>
                    <small class="font-weight-bold">CÓDIGO SCANER</small>
                  </th> -->
                  <th><small class="font-weight-bold">IP</small></th>
                  <th><small class="font-weight-bold">ACCIÓN</small></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in equipos" :key="index">
                  <!-- <td class="text-center">
                    <small>{{ index + 1 }}</small>
                  </td> -->
                  <td>
                    <small>{{ item.nombre }}</small>
                  </td>
                  <td class="text-center">
                    <small> {{ item.ip }}</small>
                  </td>
                  <td class="text-center">
                    <a
                      class="btn btn-outline-success btn-sm"
                      @click="registrarVuelo(item)"
                      title="Asignar Equipo"
                    >
                      AÑADIR <i class="fa fa-chevron-right"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
            
          </div>
          <!--Derecha-->
          <div class="col-12 col-md-7">
            <h6 class="title-panel">EQUIPOS ASIGNADOS</h6>
            <table class="table table-striped table-bordered">
              <thead>
                <tr class="text-center">
                  <!-- <th><small class="font-weight-bold">#</small></th> -->
                  <th>
                    <small class="font-weight-bold">NOMBRE EQUIPO</small>
                  </th>
                  <th><small class="font-weight-bold">IP</small></th>
                  <th><small class="font-weight-bold">FECHA</small></th>
                  <th><small class="font-weight-bold">ACCIÓN</small></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in asignados" :key="index">
                  <!-- <td class="text-center"><small>{{ index + 1 }}</small></td> -->
                  <td><small>{{ item.nombre }}</small></td>
                  <td class="text-center"><small>{{ item.ip }}</small></td>
                  <td class="text-center"><small>{{ item.fecha_reg }}</small></td>
                  <td class="text-center">
                    <a
                      class="btn btn-outline-danger btn-sm mr-2"
                      @click="darBajaVuelo(item.id_configuracion,item.ip)"
                      title="Quitar Equipo"
                    >
                      <i class="fa fa-chevron-left"></i> QUITAR
                    </a>
                    <button
                      type="button"
                      class="btn btn-info btn-sm"
                      @click="ReiniciarRobot(item.ip)"
                    >
                      <i class="fa fa-refresh"></i> REINICIAR
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        
      </div>
    </div>

    <Loading v-show="cargando" />

  </div>
</template>

<script>
import Loading from "../../components/Loading";
import { required } from "vuelidate/lib/validators";
import moment from "moment";
//import Knob from "../../components/knob.vue";
import Vue from 'vue';

export default {
  name: "vuelos",
  components: {
    Loading,
    //Knob
  },
  data() {
    return {
      //fecha_hoy: new Date(),
      fecha_hoy: new moment().format("YYYY-MM-DD HH:MI:SS"),
      vuelos: [],
      equipos: [],
      vempresas: [],
      confempresa: [],
      equiponoasig: [],
      id_accion: false,
      nombre_empresas: {
        id_empresa: "",
      },
      vuelo: {
        id_equipo: "",
        id_config_empresa: "",
        estado_registro: 1,
      },
      tituloModal: "REGISTRO DE PERSONA",
      empresa: {},
      persona: {},
      empresas: [],
      fechaInicio: "",
      fechaFin: "",
      divSemPer: false,
      divDir: false,
      divStr: false,
      parte: {
        // id_config_empresa: "",
        //id_config_empresa: 'LPES01FLCE211',
      },
      asignacion: {},
      estadoBoton: true,
      buscarNumeroDocumento: "",
      buscarNombres: "",
      buscarApellidos: "",
      extranjeros: [],
      extrajerosPartes: [],
      asignados: [],
      asignados1: [],
      personaNuevo: {},
      submitted: false,
      tipoSexos: [],
      options: [],
      item: {},
      tipoDocumentos: [],
      dismissSecs: 2,
      dismissCountDown: 0,
      dismissSecsDelete: 2,
      dismissCountDownDelete: 0,
      tipo_servicio: "",
      cargando: false,
      vuelosAsignados: [],
      vuelosActivos: [],
      id_config_empresa: '',
    };
  },
  methods: {
    async getVuelo() {
      let config = { headers: { token: this.token } };
      try {
        let resultados = await this.axios.get(`/getVuelos`, config);
        this.vuelos = resultados.data.contenido;
      } catch (error) {
        console.log("catch: ", error);
      }
    },
    async getConfigEmpresa(id_config_empresa) {
      this.cargando = true;
      try {
        this.cargando = false;
        let resultados = await this.axios.get(`/getConfig_empresa/${id_config_empresa}`
        );
        this.confempresa = resultados.data.contenido;
        this.cargando = false;
      } catch (error) {
        console.log("catch: ", error);
      }
    },
    async getNombreEmpresas() {
      try {
        let resultados = await this.axios.get(`/get_Empresa_Vuelo`);
        this.vempresas = resultados.data.contenido;
      } catch (error) {
        console.log("catch: ", error);
      }
    },
    async buscarAsignados(id_config_empresa) {
      this.cargando = true;
      try {
        this.cargando = false;
        if(id_config_empresa!==''){ 
          let resEquipos = await this.axios.get(`/equiposNoasignados`);
          this.equipos = resEquipos.data.contenido;

          let resEmpresa = await this.axios.get(`/buscar_equipo_asignado/${id_config_empresa}`);
          this.asignados = resEmpresa.data.contenido;
        }
        
      } catch (error) {
        this.cargando = false;
        console.log("Error catch: ", error);
      }
      
    },
    async quitarRegistro(item){
      this.asignados = this.asignados.filter((e)=> {return e !=item })
    },
     async quitarRegistroEquipo(item){
     this.equipos = this.equipos.filter((e)=> {return e !=item })
    },
    async registrarVuelo(item) {
      this.cargando = true;
      try {
        this.parte.id_equipo = item.id_equipo;
        this.parte.id_config_empresa = this.vuelo.id_config_empresa;
        this.cargando = false;
        // verifica datos de parte
        if(this.parte.id_config_empresa == ''){
          this.$swal({
            html: 'Tiene que seleccionar <b>Empresa</b> y <b>Vuelo</b><br/>para añadir el equipo.',
            type: 'info',
            confirmButtonText: 'Aceptar'
          });
        }
        else{
          await this.axios.post(`/insert_vuelo`, this.parte);
          this.$swal({
            html: 'Equipo asignado correctamente.',
            type: 'success',
            confirmButtonText: 'Aceptar'
          })
          .then(()=>{
            this.buscarAsignados(this.vuelo.id_config_empresa)
            //this.VueloActivo();
            //this.asignados.push(item);

            this.Limpiar();
          });
          
          // actualiza cantidad
          this.VueloActivo();

          // inicia el equipo robot
          //ip, codigo_scanner
          let ip = item.ip;         
          let codigo_scaner = item.codigo_scaner;
          let data = {
            codigo_equipo: codigo_scaner
          }
          await this.axios.post(`http://${ip}:8520/api/robot/v3/iniciarEquipo`, data);
          
        }
      } catch (error) {
        this.cargando = false;
        console.log("Error catch: ", error);
      }
    },
   async ReiniciarRobot(ip){     
      try {      
       let result = await this.axios.get(`reiniciarEquipo/${ip}`);       
        if(result.status === 200){
          this.$swal({
            title: "Equipo Reiniciado",
            type: "success",
            confirmButtonText: "Aceptar",
          });
        }
      } catch (error) {
        console.error(error);
      }
    },
    darBajaVuelo(id_configuracion,ip) {
      this.$swal({
        title: "Esta Seguro?",
        html: "De <b>quitar</b> el equipo del Vuelo.",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, Quitar Equipo",
      })
      .then(async (result) => {
        if (result.value) {
          try {        
          await this.axios.put(`/darBajaVuelos/${id_configuracion}/${ip}`);           
          this.Asignaciones(); 
          this.buscarAsignados(this.vuelo.id_config_empresa)
          this.$swal({
              text: 'Acción realizada correctamente',
              type: 'success',
              confirmButtonText: 'Aceptar'
            });   
            this.VueloActivo();       
          } catch (error) {
            console.log(error);
          }
        }
      });
    },

    Limpiar() {
     this.vuelo.id_config_empresa="",
     this.nombre_empresas.id_empresa=""
    },
 

    getDate: function() {
      return moment().format("YYYY-MM-DD");
    },
    formatFecha(event) {
      let str = event;
      let arrayFecha = str.split("-");
      return arrayFecha[2] + "/" + arrayFecha[1] + "/" + arrayFecha[0];
    },
    showAlert() {
      this.$swal({
        text: "Ingreso Registrado",
        type: "success",
        confirmButtonText: "Aceptar",
      });
    },
    showAlertSalida() {
      this.$swal({
        text: "Salida Registrada",
        type: "success",
        confirmButtonText: "Aceptar",
      });
    },
    showAlertDelete() {
      this.$swal({
        text: "Registro Cancelado",
        type: "warning",
        confirmButtonText: "Aceptar",
      });
    },
    async Asignaciones() {
      this.cargando = true;
      try {
        //vuelosAsignados
        let resultVuelosAsignados = await this.axios.get(`/vuelosAsignados`);
        
        this.vuelosAsignados = resultVuelosAsignados.data.contenido;
        //console.log("vuelo:",this.vuelosAsignados);
        if(this.vuelosAsignados.length > 0){
          this.id_config_empresa = this.vuelosAsignados[0].id;         
          // equipos asignados
          let resultAsignados = await this.axios.get(`/buscar_equipo_asignado/${this.id_config_empresa}`);
          this.asignados = resultAsignados.data.contenido;

        }
        this.cargando = false;
        // equipos no asignados
        let resultNoAsignados = await this.axios.get(`/equiposNoasignados`);
        this.equipos = resultNoAsignados.data.contenido;
        
        
      } catch (error) {
        this.cargando = false;
        console.log("Error catch: ", error);
      }
      
    },
    async VueloActivo() {
      try {
        let result = await this.axios.get(`/vueloActivo`);
        this.vuelosActivos = result.data.contenido;
      } catch (error) {
        this.cargando = false;
        console.log("Error catch: ", error);
      }
     
    },
    async setConfiguracionFlujo() {
      this.cargando = true;
      try {
        this.cargando = false;
        // verifica
        this.$swal({
          title: "Esta Seguro?",
          html: "De reiniciar la configuración de vuelos",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Si, Reiniciar",
          cancelButtonText: 'Cancelar'
        })
        .then(async (result) => {
          if (result.value) {
            //vuelosActivo
            let result = await this.axios.put(`/setConfiguracionFlujo`);
            //console.log("resultados:::::",result);
            if(result.status === 200){
              this.$swal({
                text: "Configuración de vuelos reiniciado",
                type: "success",
                confirmButtonText: "Aceptar",
              })
              .then(()=>{
                // actualiza asignaciones
                this.Asignaciones();
                this.VueloActivo();

              });
              
            }
            
          }
        });

      } catch (error) {
        this.cargando = false;
        console.log("Error catch: ", error);
      }
      
    },
    async Revisar(id){
      this.id_config_empresa = id;
      let result = await this.axios.get(`/buscar_equipo_asignado/${this.id_config_empresa}`);
      if(result.status === 200){
        this.asignados = result.data.contenido;
      }
      
    }
  },
  created() {
    //this.getVuelo();
    // cantidad de equipos en vuelo
    this.VueloActivo();
    this.Asignaciones();
    //this.getEquipos();
   // this.getConfigEmpresa();
    this.getNombreEmpresas();
    this.Limpiar();
    //this.buscarAsignados(this.vuelo.id_config_empresa);
  },
  mounted () {
    Vue.set(this.vuelosActivos);
  },
  validations: {
    vuelo: {
      id_equipo: { required },
      id_config_empresa: { required },
    },
    nombre_empresas: {
      id_empresa: { required },
    },
    parte: {
      id_config_empresa: { required },
    },
  },
};

</script>
